import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Imprint from './pages/Imprint';
import Privacy from './pages/Privacy';

function App() {
  return (
    <Router>
      <main className="w-full min-h-screen bg-etera-ivory selection:bg-etera-gold selection:text-etera-black">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;